// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/rollapp/genesis_info.proto (package dymensionxyz.dymension.rollapp, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { DenomMetadata } from "./metadata_pb.js";

/**
 * @generated from message dymensionxyz.dymension.rollapp.GenesisInfo
 */
export class GenesisInfo extends Message<GenesisInfo> {
  /**
   * checksum used to verify integrity of the genesis file
   *
   * @generated from field: string genesis_checksum = 1;
   */
  genesisChecksum = "";

  /**
   * unique bech32 prefix
   *
   * @generated from field: string bech32_prefix = 2;
   */
  bech32Prefix = "";

  /**
   * native_denom is the base denom for the native token
   *
   * @generated from field: dymensionxyz.dymension.rollapp.DenomMetadata native_denom = 3;
   */
  nativeDenom?: DenomMetadata;

  /**
   * initial_supply is the initial supply of the native token
   *
   * @generated from field: string initial_supply = 4;
   */
  initialSupply = "";

  /**
   * sealed indicates if the fields in this object are no longer updatable
   *
   * @generated from field: bool sealed = 5;
   */
  sealed = false;

  /**
   * @generated from field: dymensionxyz.dymension.rollapp.GenesisAccounts genesis_accounts = 6;
   */
  genesisAccounts?: GenesisAccounts;

  constructor(data?: PartialMessage<GenesisInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.GenesisInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "genesis_checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bech32_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "native_denom", kind: "message", T: DenomMetadata },
    { no: 4, name: "initial_supply", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sealed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "genesis_accounts", kind: "message", T: GenesisAccounts },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenesisInfo {
    return new GenesisInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenesisInfo {
    return new GenesisInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenesisInfo {
    return new GenesisInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GenesisInfo | PlainMessage<GenesisInfo> | undefined, b: GenesisInfo | PlainMessage<GenesisInfo> | undefined): boolean {
    return proto3.util.equals(GenesisInfo, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.GenesisAccounts
 */
export class GenesisAccounts extends Message<GenesisAccounts> {
  /**
   * @generated from field: repeated dymensionxyz.dymension.rollapp.GenesisAccount accounts = 1;
   */
  accounts: GenesisAccount[] = [];

  constructor(data?: PartialMessage<GenesisAccounts>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.GenesisAccounts";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accounts", kind: "message", T: GenesisAccount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenesisAccounts {
    return new GenesisAccounts().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenesisAccounts {
    return new GenesisAccounts().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenesisAccounts {
    return new GenesisAccounts().fromJsonString(jsonString, options);
  }

  static equals(a: GenesisAccounts | PlainMessage<GenesisAccounts> | undefined, b: GenesisAccounts | PlainMessage<GenesisAccounts> | undefined): boolean {
    return proto3.util.equals(GenesisAccounts, a, b);
  }
}

/**
 * GenesisAccount is a struct for the genesis account for the rollapp
 *
 * @generated from message dymensionxyz.dymension.rollapp.GenesisAccount
 */
export class GenesisAccount extends Message<GenesisAccount> {
  /**
   * amount of coins to be sent to the genesis address
   *
   * @generated from field: string amount = 1;
   */
  amount = "";

  /**
   * address is a bech-32 address of the genesis account
   *
   * @generated from field: string address = 2;
   */
  address = "";

  constructor(data?: PartialMessage<GenesisAccount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.GenesisAccount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenesisAccount {
    return new GenesisAccount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenesisAccount {
    return new GenesisAccount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenesisAccount {
    return new GenesisAccount().fromJsonString(jsonString, options);
  }

  static equals(a: GenesisAccount | PlainMessage<GenesisAccount> | undefined, b: GenesisAccount | PlainMessage<GenesisAccount> | undefined): boolean {
    return proto3.util.equals(GenesisAccount, a, b);
  }
}

